var _defs, _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeBasedBonus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M18.534 13.25h10.995v6.19a4.807 4.807 0 01-4.805 4.805H23.34a4.807 4.807 0 01-4.805-4.805v-6.19zM24.031 24.245V29.1M19.747 29.492h8.568M29.529 17.891h2.025M16.508 17.891h2.026"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 36.279,
    cy: 28.667,
    r: 1.445
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M11.181 8.786a3.84 3.84 0 10-7.68 0v3.215h7.638l.042-3.215zM11.138 12.001v25.634h25.141v-4.33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M7.615 4.945h24.824a3.84 3.84 0 013.84 3.84v14.904"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeBasedBonus);
export default __webpack_public_path__ + "static/media/TimeBasedBonus.42aecd9d85c43e26880d28a8edd6f04b.svg";
export { ForwardRef as ReactComponent };